import React from 'react';
import classnames from 'classnames';
import { withLocalize, Translate } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { relationsSearchActions, defaultPaging, searchType, defaultOrderBy, searchInstances, searchInstancesWithSaveEnabled } from '../../../store/relationsSearchStore';
import { isObjectPathDefined } from "../../../store/apiWrapper";
import { domainActions } from '../../../store/domainStore';
import { layoutActions } from '../../../store/layoutStore';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import { parseQuery } from '../../../store/apiWrapper';
import { Circles } from '../../common/loadingComponent';
import NoDataComponent from '../../common/noDataComponent';
import ErrorComponent from '../../common/errorComponent';
import RelationSearchSearchRow from './relationsSearchSearchRow';
import Paging from '../../common/pagingComponent';
import ReactResizeDetector from 'react-resize-detector';
import BbRadioWrapper from '../../styling/BbRadioWrapper';
import BbCheckbox from '../../styling/bbCheckbox';
import PerfectScrollbar from 'react-perfect-scrollbar';

import '../../../css/search/search.scss'

class RelationsSearchSearchResults extends React.Component {
    state = {
        maxTableWidth: 0,
        checkedEntities: [],
        onlyCheckedEntity: undefined
    };

    render() {
        const isSearching = this.props[this.props.searchInstance.key].isSearching;
        const searchResult = this.props[this.props.searchInstance.key].searchResult;

        return (
            <div className='w-100' style={{ borderTop: '1px solid rgb(222, 222, 222)' }}>
                {isSearching && <Circles />}
                {!isSearching && this.areAnyResults(searchResult) && this.renderWithResults()}
                {!isSearching && !this.areAnyResults(searchResult) && this.renderNoResult(searchResult)}
            </div>
        )
    }

    renderHeader = (sr) => {
        if (!this.areAnyResults(sr))
            return null;

        let currentFound = isNullOrUndefined(this.props[this.props.searchInstance.key].entityId) ? sr.data.subjects.length : 1;
        let totalFound = isNullOrUndefined(this.props[this.props.searchInstance.key].entityId) ? sr.data.totalFound : 1;

        return (
            <div className="relationsSearch-card-header relationsSearch-card-header-results" >
                <span>
                    <Translate id='SearchResult.ResultsCount' />:&nbsp;
                    <b>{currentFound}</b> |&nbsp;
                    <Translate id='SearchResult.TotalResults' />:&nbsp;
                    <b>{totalFound}</b>
                </span>
            </div>
        );
    }

    renderWithResults() {
        const searchResult = this.props[this.props.searchInstance.key].searchResult;

        return (
            <>
                {this.renderError(searchResult)}
                {searchResult.data.subjects.length > 0 &&
                    <>
                        {this.renderHeader(searchResult)}
                        <div style={{ padding: '0em 1em' }}>
                            <PerfectScrollbar options={{ suppressScrollX: true }} style={{ maxHeight: "50em" }}>
                                {this.renderSubjectTable(!isNullOrUndefined(this.props[this.props.searchInstance.key].entityId) ? searchResult.data.subjects.filter(s => s.entityId === this.props[this.props.searchInstance.key].entityId) : searchResult.data.subjects)}
                            </PerfectScrollbar>
                        </div>
                        {this.renderBottomPanel(searchResult)}
                    </>
                }
            </>
        )
    }

    componentDidMount() {
        this.props.initializeFromLocalStorage(this.props.searchInstance.key);
        if (!isNullOrUndefined(this.props[this.props.searchInstance.key].entityId)) {
            this.props.setEntityId(this.props.searchInstance.key, this.props[this.props.searchInstance.key].entityId);
        }
        this.getData();
    }

    getData = () => {
        // const qs = parseQuery(window.location.search);
        const qs = parseQuery(`?${this.props.searchInstance.query}`);
        let needReset = !isNullOrUndefined(qs.q) || !searchInstancesWithSaveEnabled.includes(this.props.searchInstance.key);

        let params = {};
        if (!needReset) {
            return;
        } else {
            params = { country: 3, actualOnly: true };
            if (qs.q !== undefined && qs.q !== '') {

                let icoDicIcdph = /^(([0-9]{8}|[0-9]{10}|[a-z]{2}[0-9]{8,10})(\s|[,;]|OR)*)+$/gi;
                let icoDicIcdph2 = /^([0-9]{8}|[0-9]{10}|[a-z]{2}[0-9]{8,10})$/gi;
                if (icoDicIcdph.test(qs.q))
                    params.icoDic = qs.q.split(/(?:\s|[,;]|OR)+/gi);
                else if (icoDicIcdph2.test(qs.q.replace(/\s/g, '')))
                    params.icoDic = [qs.q.replace(/\s/g, '')];
                else
                    params.name = qs.q;
            }
            if (isNullOrUndefined(qs.isPo) || qs.isPo === '')
                params.isPo = null;
            else
                params.isPo = qs.isPo === "true";
            if (!isNullOrUndefined(qs.street)) params.street = qs.street;
            if (!isNullOrUndefined(qs.bankAccount)) params.bankAccount = qs.bankAccount;
            if (!isNullOrUndefined(qs.dob)) params.dob = qs.dob;
            if (!isNullOrUndefined(qs.rdcIds)) params.rdcIds = qs.rdcIds.split(",");

            this.props.getRelationsSubjects(this.props.searchInstance.key, qs.type || searchType.QS, params, { ...defaultPaging }, defaultOrderBy);
            this.props.setSearchParams(this.props.searchInstance.key, params);
            this.getRdcIfNeeded();
        }
    }

    getRdcIfNeeded = () => {

        if (isObjectPathDefined(this.props, 'searchDomains') && !isNullOrUndefined(this.props[this.props.searchInstance.key].searchDomains.rdcIds)) {
            //if coming from /search, this data should be filled
            return;
        }
        else {
            this.props.ensureDomainData('region-district-city');
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.searchInstance.query !== this.props.searchInstance.query) {
            this.getData();
            this.setState({ checkedEntities: [], onlyCheckedEntity: undefined }, () => {
                this.props.onAction("check", this.state.checkedEntities);
                this.props.onAction("hasResults", false);
            })
            return;
        }

        //wait for rdc to load then parse from query string and put to store
        if (!this.domainsLoading() && this.props[this.props.searchInstance.key].searchDomains === null) {
            // const qs = parseQuery(window.location.search);
            const qs = parseQuery(`?${this.props.searchQuery}`);
            if (!isNullOrUndefined(qs.rdcIds)) {
                let splitted = qs.rdcIds.split(",");
                let rdc = [];
                splitted.map(s => {
                    let found = this.props.domain['region-district-city'].requestResult.find(x => x.value === s);
                    rdc[found.value] = found.label;
                })
                this.props.setRelationSearchDomain(this.props.searchInstance.key, { rdcIds: rdc });
            }
        }
        if (this.props[this.props.searchInstance.key].languageChanged)
            this.props.repeatSearch(this.props.searchInstance.key);

        // after rendering a single checked result it sets its entityid as checkedEntityId
        const isSearching = this.props[this.props.searchInstance.key].isSearching;
        const searchResult = this.props[this.props.searchInstance.key].searchResult;
        if (!isSearching && this.areAnyResults(searchResult))
            if ((searchResult.data.subjects.length === 1) && (searchResult.data.subjects[0].entityId !== this.state.onlyCheckedEntity)) {
                this.setState({ onlyCheckedEntity: searchResult.data.subjects[0].entityId, checkedEntities: [searchResult.data.subjects[0].entityId] },
                    () => {
                        this.props.onAction("check", [this.state.onlyCheckedEntity]);
                    });
            } else if (this.state.checkedEntities.length === 0 && !isNullOrUndefined(this.props[this.props.searchInstance.key].entityId)) {
                this.setState({ checkedEntities: [this.props[this.props.searchInstance.key].entityId] },
                    () => {
                        this.props.onAction("check", [this.state.checkedEntities[0]]);
                    });
            }

        if (!isSearching && this.areAnyResults(searchResult)) {
            this.props.onAction("hasResults", true);
        }
    }
    domainsLoading = () => {
        return this.props.domain['region-district-city'].isRequesting || this.props.domain['region-district-city'].requestResult == null;
    }

    renderBottomPanel = (sr) => {
        if (!this.areAnyResults(sr) || !isNullOrUndefined(this.props[this.props.searchInstance.key].entityId))
            return null;

        const searchPaging = this.props[this.props.searchInstance.key].searchPaging;
        if (!(Math.ceil(sr.data.totalFound / searchPaging.count) < 2)) {
            return (
                <div style={{ margin: '1em 0' }}>
                    <Paging justify="center"
                        selectedPage={searchPaging.page}
                        totalPages={Math.ceil(sr.data.totalFound / searchPaging.count)}
                        setPage={this.onPageClick} />
                </div>
            )
        }

        return null;
    }

    renderError = (sr) => {
        if (isNullOrUndefined(sr) || isNullOrUndefined(sr.data) || isNullOrUndefined(sr.data.error))
            return null;

        return (<>
            <ErrorComponent message={sr.data.error.reason} back={<>
                <button onClick={() => {
                    this.props.toggleForm(this.props.searchInstance.key, true);
                    this.props.onAction("back", undefined)
                }}
                    className={classnames('bb-button small gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })} style={{ marginTop: "1em", marginBottom: "1em" }}>
                    {this.props.translate('Common.Back')}
                </button>
            </>} />
        </>);
    }

    renderNoResult = (sr) => {
        if (isNullOrUndefined(this.props.searchInstance.query))
            return null;
        if (!isNullOrUndefined(sr) && !isNullOrUndefined(sr.data) && !isNullOrUndefined(sr.data.error) && !isNullOrUndefined(sr.data.error.reason))
            return this.renderError(sr);
        else if (isNullOrUndefined(sr) || isNullOrUndefined(sr.data) || !Array.isArray(sr.data.subjects) || sr.data.subjects.length < 1)
            return this.renderNoSubjectFound();
        else return null;
    }

    renderNoSubjectFound = () => {
        return (
            <div style={{ margin: "1em" }}>
                <NoDataComponent />
            </div>);
    }

    renderSubjectTable = (subjects) => {
        const checkbox = (isNullOrUndefined(this.props.checkType) || this.props.checkType === "check");
        const noneCheckType = (!isNullOrUndefined(this.props.checkType) && this.props.checkType === "none");

        return (<>
            <ReactResizeDetector handleWidth refreshMode='debounce' refreshRate={500} onResize={this.onResize} />
            <div className="table sr-table">
                <div className="sr-result" key={'probe-row'} style={{ borderWidth: 0 }}>
                    <div ref={el => this.probeNumRow = el}></div>
                    <div>
                        <div ref={el => this.probeTrigger = el} style={{ width: '1cm' }}></div>
                    </div>
                </div>
                {subjects.map((s, i) => {
                    return (
                        <div className="sr-result" key={s.entityId}>
                            <div className="sr-result-index">
                                {(checkbox && <BbCheckbox
                                    id={`checkbox-${s.entityId}-${this.props.searchInstance.key}`}
                                    value={this.state.checkedEntities.includes(s.entityId)}
                                    onChange={(value) => this.onCheckboxClick(value, s.entityId)}
                                    disabled={subjects.length < 2}
                                />)}
                                {((!checkbox && !noneCheckType) && <BbRadioWrapper
                                    name={`radio-${s.entityId}-${this.props.searchInstance.key}`}
                                    id={`radio-${s.entityId}-${this.props.searchInstance.key}`}
                                    checked={this.state.checkedEntities.includes(s.entityId)}
                                    callback={() => this.onRadioClick(s.entityId)}
                                />)}
                            </div>
                            <div className="sr-result-index">{i + 1 + this.props[this.props.searchInstance.key].searchPaging.offset}.</div>
                            <div><RelationSearchSearchRow s={s} maxTableWidth={this.state.maxTableWidth} /></div>
                        </div>
                    )
                })}
            </div>
        </>);
    }

    onResize = (width, height) => {
        const numberRow = (this.probeNumRow || { getBoundingClientRect: function () { return {} } }).getBoundingClientRect().width || 0;
        const triggerW = (this.probeTrigger || { getBoundingClientRect: function () { return {} } }).getBoundingClientRect().width || 0;
        this.setState({ maxTableWidth: width - numberRow - triggerW });
    }

    onCheckboxClick = (value, entityId) => {
        let subjs = Object.assign([], this.state.checkedEntities);

        if (value) {
            subjs.push(entityId);
        } else {
            subjs = subjs.filter(sub => sub !== entityId);
        }

        this.setState({ checkedEntities: subjs },
            () => this.props.onAction("check", this.state.checkedEntities));
    }

    onRadioClick = (entityId) => {
        let subjs = [entityId];
        this.setState({ checkedEntities: subjs },
            () => this.props.onAction("check", this.state.checkedEntities));
    }

    areAnyResults = sr => {
        // Don't render if any error is present.
        if (!isNullOrUndefined(sr) && !isNullOrUndefined(sr.data) && !isNullOrUndefined(sr.data.error))
            return false;

        if (isNullOrUndefined(sr) || isNullOrUndefined(sr.data) || !Array.isArray(sr.data.subjects) || sr.data.subjects.length < 1)
            return false;

        return true;
    }

    onPageClick = (page) => {
        this.props.changePage(this.props.searchInstance.key, page);

        if (!isNullOrUndefined(this.props.scroller)) {
            this.props.scroller.scrollTop = 0;
        }
    }
}

export default withRouter(withLocalize(connect(
    state => ({ ...state.relationsSearch, domain: state.domain }),
    dispatch => bindActionCreators(Object.assign({}, relationsSearchActions, domainActions, layoutActions), dispatch),
)(RelationsSearchSearchResults)));